import { Project, ContactInfo } from '../types';
import { ReactComponent as DotnetIcon } from '../assets/images/stack/dotnet.svg';

export const projects: Project[] = [
  {
    id: 1,
    title: "Vincent Petit Apiculteur",
    description: "Site vitrine. Tout peut être facilement mis à jour grâce à une interface d'administration.",
    longDescription: "Site vitrine réalisé en HTML/CSS/PHP avec quelques lignes de JavaScript. Interface d'administration complète pour la gestion du contenu.",
    technologies: ["HTML", "CSS", "PHP", "JavaScript"],
    images: [
      require("../assets/images/vincent/landing-1.jpg"),
      require("../assets/images/vincent/front.png"),
      require("../assets/images/vincent/back1.png"),
      require("../assets/images/vincent/back2.png")
    ],
    liveUrl: "https://petitmiel.cyrilletual.fr/",
    githubUrl: "https://github.com/CyrilleTual/Honey_public",
    category: "web"
  },
  {
    id: 2,
    title: "Trading Tool",
    description: "Application pour traders amateurs. Full JS : React pour la partie frontend et node/express pour le backend.",
    longDescription: "Application complète de trading avec React, Node.js/Express, base de données hébergée et déploiement Docker.",
    technologies: ["React", "Node.js", "Express", "Docker", "JavaScript"],
    images: [
      require("../assets/images/tradingTool/tradingTool_1.jpg"),
      require("../assets/images/tradingTool/trade1.jpg"),
      require("../assets/images/tradingTool/trade2.jpg"),
      require("../assets/images/tradingTool/trade3.jpg")
    ],
    liveUrl: "https://trading-helper.cyrilletual.fr/",
    githubUrl: "https://github.com/CyrilleTual/trading_helper_client",
    category: "fullstack"
  },
  {
    id: 3,
    title: "GameGalaxy",
    description: "Site de vente en ligne de jeux vidéo réalisé en équipe de 3 dans le cadre de ma formation .NET.",
    longDescription: "Projet d'équipe avec ASP.NET Web API en C# pour le backend et Angular pour le frontend. J'ai principalement pris en charge la réalisation de la partie Frontend.",
    technologies: ["Angular", "ASP.NET", "C#", "TypeScript"],
    images: [
      require("../assets/images/galaxy/galaxy1.png"),
      require("../assets/images/galaxy/galaxy2.png"),
      require("../assets/images/galaxy/galaxy3.png"),
      require("../assets/images/galaxy/galaxy4.png")
    ],
    githubUrl: "https://github.com/CyrilleTual/projet-final-ajc",
    category: "fullstack"
  },
  {
    id: 4,
    title: "Blog NextJs",
    description: "Exercice NextJs avec TypeScript, ReactQuery, Axios et Prisma.",
    longDescription: "Blog moderne développé avec Next.js, TypeScript, ReactQuery pour la gestion d'état, Axios pour les requêtes HTTP et Prisma comme ORM.",
    technologies: ["Next.js", "TypeScript", "ReactQuery", "Axios", "Prisma"],
    images: [
      require("../assets/images/nextjs/landing.jpg"),
      require("../assets/images/nextjs/redaction-article.jpg"),
      require("../assets/images/nextjs/commentaires.jpg")
    ],
    liveUrl: "https://nextjs-blog-cyrille.vercel.app/",
    githubUrl: "https://github.com/CyrilleTual/nextjs-blog",
    category: "fullstack"
  },
  {
    id: 5,
    title: "Intégration d'un éditeur WYSIWYG",
    description: "Article NextJs pour LinkedIn avec Next.js 14.2.13, sqlite3, Prisma 5.20.0, ReactQuillNew 3.3.2.",
    longDescription: "Implémentation d'un éditeur WYSIWYG avec upload d'images, compression automatique et stockage optimisé.",
    technologies: ["Next.js", "SQLite", "Prisma", "ReactQuill"],
    images: [
      require("../assets/images/nextjsquill/quill.png")
    ],
    liveUrl: "https://nextjsquill.cyrilletual.fr",
    githubUrl: "https://github.com/CyrilleTual/nextjs-quill-prisma-sqlite",
    category: "fullstack"
  },
  {
    id: 6,
    title: "Podual",
    description: "Site de mise en contact podcasteurs et experts. Projet Next.js 15 avec SSR et server actions.",
    longDescription: "Plateforme web Next.js/React avec TypeScript, intégration Stripe pour les abonnements, PostgreSQL via Prisma, authentification Supabase, design responsive avec Tailwind CSS.",
    technologies: ["Next.js", "React", "TypeScript", "Stripe", "PostgreSQL", "Prisma", "Supabase", "Tailwind CSS"],
    images: [
      require("../assets/images/podual/podual.png")
    ],
    liveUrl: "https://podual.fr/",
    githubUrl: "https://github.com/CyrilleTual/coco",
    category: "fullstack"
  }
];

export const skills = [
  // --- 1️⃣ Cœur d’expertise ---
  { name: "React 18/19", icon: "fab fa-react", level: 95, category: "Cœur d’expertise" },
  { name: "TypeScript", icon: "fab fa-js", level: 95, category: "Cœur d’expertise" },
  { name: "Next.js", icon: "fab fa-react", level: 90, category: "Cœur d’expertise" },
  { name: "Zustand", icon: "fas fa-store", level: 85, category: "Cœur d’expertise" },
  { name: "TanStack Query", icon: "fas fa-cloud", level: 85, category: "Cœur d’expertise" },

  // --- 2️⃣ UI & Design ---
  { name: "CSS3", icon: "fab fa-css3-alt", level: 90, category: "UI & Design" },
  { name: "MUI", icon: "fas fa-layer-group", level: 85, category: "UI & Design" },
  { name: "Tailwind CSS", icon: "fas fa-wind", level: 90, category: "UI & Design" },
  { name: "shadcn/ui", icon: "fas fa-layer-group", level: 85, category: "UI & Design" },
  { name: "Framer Motion", icon: "fas fa-film", level: 70, category: "UI & Design" },
  { name: "Lucide React", icon: "fas fa-icons", level: 70, category: "UI & Design" },

  // --- 3️⃣ Back-end & Data ---
  { name: "Node.js", icon: "fab fa-node-js", level: 60, category: "Back-end & Data" },
  { name: "Supabase", icon: "fas fa-database", level: 75, category: "Back-end & Data" },
  { name: "Firebase", icon: "fas fa-fire", level: 70, category: "Back-end & Data" },
  { name: "PostgreSQL", icon: "fas fa-database", level: 75, category: "Back-end & Data" },
  { name: "MySQL", icon: "fas fa-database", level: 60, category: "Back-end & Data" },
  { name: "Prisma", icon: "fas fa-database", level: 75, category: "Back-end & Data" },
  { name: "Axios", icon: "fas fa-plug", level: 80, category: "Back-end & Data" },
  { name: "Angular", icon: require("../assets/images/stack/angularicon.png"), level: 50, category: "Back-end & Data" },
  { name: "PHP", icon: "fab fa-php", level: 45, category: "Back-end & Data" },
  { name: ".NET / C#", icon: DotnetIcon, level: 30, category: "Back-end & Data" },

  // --- 4️⃣ IA & Automatisation ---
  { name: "Agents IA", icon: "fas fa-robot", level: 90, category: "IA & Automatisation" },
  { name: "Serveurs MCP", icon: "fas fa-server", level: 85, category: "IA & Automatisation" },
  { name: "Prompt engineering", icon: "fas fa-comment-dots", level: 85, category: "IA & Automatisation" },
  { name: "LLMs locaux (Ollama)", icon: "fas fa-brain", level: 80, category: "IA & Automatisation" },
  { name: "Orchestration multi-agents", icon: "fas fa-project-diagram", level: 75, category: "IA & Automatisation" },

  // --- 5️⃣ DevOps & Infra ---
  { name: "Docker", icon: "fab fa-docker", level: 75, category: "DevOps & Infra" },
  { name: "Traefik", icon: "fas fa-network-wired", level: 70, category: "DevOps & Infra" },
  { name: "GitHub Actions", icon: "fab fa-github", level: 70, category: "DevOps & Infra" },
  { name: "Self-hosting", icon: "fas fa-server", level: 75, category: "DevOps & Infra" },
  { name: "Git", icon: "fab fa-git-alt", level: 85, category: "DevOps & Infra" },
  { name: "VS Code", icon: "fas fa-code", level: 90, category: "DevOps & Infra" },
  { name: "Postman", icon: "fas fa-vial", level: 70, category: "DevOps & Infra" },
  { name: "Jira", icon: "fas fa-tasks", level: 75, category: "DevOps & Infra" },
  { name: "Swagger", icon: "fas fa-file-code", level: 70, category: "DevOps & Infra" },

] as const;


export const contactInfo: ContactInfo = {
  email: "cyrille.tual@gmail.com",
  linkedin: "https://www.linkedin.com/in/cyrille-tual/",
  github: "https://github.com/CyrilleTual",
  // Cal.com booking page ("<user>/<event>"), see src/utils/calendar.ts
  calLink: "cyrille-tual/15min"
};

export const personalInfo = {
  name: "Cyrille Tual",
  title: "Front-ends React robustes pour SaaS métier",
  subtitle: "",
  description: [
    "Développeur front-end React / TypeScript, j'interviens sur des interfaces complexes, avec un focus sur la structuration du code, la cohérence UI et la performance. J'intègre des outils d'IA dans mes workflows au quotidien.",
    "Basé aux Sables-d'Olonne — disponible freelance, CDD ou CDI."
  ],
  profileImage: require("../assets/images/id_cyrille.jpg"),
  // Served from public/ under a stable, unhashed URL — also shared on LinkedIn.
  cvUrl: process.env.PUBLIC_URL + '/Cyrille_TUAL_Cv.pdf'
};